<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Stoklar ({{stocks.length}})</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-menu
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="100px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="startDate"
            label="Tarih"
            prepend-icon="event"
            single-line
            hide-details
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          @change="initialize"
          v-model="startDate"
          locale="tr-TR"
          @input="menu1 = false"
        ></v-date-picker>
      </v-menu>
      <v-divider class="mx-2" inset vertical></v-divider>
      <!-- <v-text-field
        v-model="search"
        @keyup.enter.native="initialize"
        append-icon="search"
        label="Ara"
        single-line
        hide-details
      ></v-text-field>
      <v-divider class="mx-2" inset vertical></v-divider>-->

      <v-btn color="primary" dark @click="initialize" class="mb-2">Ara</v-btn>
      <!-- <v-btn color="primary" dark class="mb-2" to="/stock/detail">Yeni Ekle</v-btn> -->
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :loading="this.$store.state.progress"
      :rows-per-page-items="pageItems"
      :items="stocks"
      :pagination.sync="pagination"
      item-key="id"
      select-all
      v-model="selected"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            class="px-1 text-xs-left"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            {{header.text}} ({{sumField(header.value) }})
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <td class="px-2">{{props.item.stock.productName}}</td>
        <td class="px-1">
          <v-text-field v-model="props.item.stock.weight"></v-text-field>
        </td>
        <td class="px-1">
          <v-text-field v-model="props.item.previousCount"></v-text-field>
        </td>
        <td class="px-1">{{props.item.soldCount}}</td>
        <td class="px-1">
          {{
          parseInt(props.item.previousCount)- parseInt(props.item.soldCount)+ parseInt(props.item.receivedCount)+ parseInt(props.item.receivedCountTwo)+ parseInt(props.item.receivedCountThree)+ parseInt(props.item.receivedCountFour)
          }}
        </td>
        <td class="px-1">
          {{
          parseFloat(props.item.stock.weight)*
          parseFloat(props.item.soldCount)
          }}
        </td>
        <td class="px-1">
          <v-text-field v-model="props.item.receivedCount"></v-text-field>
        </td>
        <td class="px-1">
          <v-text-field v-model="props.item.receivedCountTwo"></v-text-field>
        </td>
        <td class="px-1">
          <v-text-field v-model="props.item.receivedCountThree"></v-text-field>
        </td>
        <td class="px-1">
          <v-text-field v-model="props.item.receivedCountFour"></v-text-field>
        </td>
      </template>
    </v-data-table>
   
    <v-layout wrap justify-space-between>
  
      <v-flex xs12 md2>
        <v-btn color="primary" dark @click="saveAction" class="mb-2">Kaydet</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import store from "@/store";
import { addDays } from "@/utils";
import {
  formatToMoney
} from "@/utils";

export default {
  data: () => ({
    startDate: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    menu1: false,
    modal: false,
    tenantId: 0,
    products: [],
    menu2: false,
    pagination: {
      sortBy: "name"
    },
    select: { id: -1, name: "Seçiniz" },
    selectedAction: { id: -1, value: "Durum Seç" },
    search: null,
    selected: [],
    stocks: [],
    pageItems: [
      1000,
      2000,
      5000,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
    ],
    headers: [
      { text: "Ürün", value: "stock.productName" },

      { text: "Gramaj", value: "weight" },
      {
        text: "A.KALAN STOK",
        value: "previousCount"
      },
      { text: "SATILAN ADET", value: "soldCount" },
      { text: "SATIŞ SONRASI KALAN ADET", value: "satis" },
      { text: "T. Gramaj", value: "tweight" },
      { text: "ALINAN ADET 1", value: "receivedCount" },
      { text: "ALINAN ADET 2", value: "receivedCountTwo" },
      { text: "ALINAN ADET 3", value: "receivedCountThree" },
      { text: "ALINAN ADET 4", value: "receivedCountFour" }
    ]
  }),
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    //this.initialize();
  },

  methods: {
    async initialize() {
      await this.$store.dispatch("stockDetails/searchStock", {
        search: this.search,
        startDate: this.startDate,
        state: this.select.id
      });
      this.stocks = this.$store.state.stockDetails.all;
    },
    sumField(field) {
      switch (field) {
        case "satis":
          var previousCount = this.selectField("previousCount");
          var soldCount = this.selectField("soldCount");
          var receivedCount = this.selectField("receivedCount");
          var receivedCountTwo = this.selectField("receivedCountTwo");
          var receivedCountThree = this.selectField("receivedCountThree");
          var receivedCountFour = this.selectField("receivedCountFour");
          return (
            parseInt(previousCount) -
            parseInt(soldCount) +
            parseInt(receivedCount) +
            parseInt(receivedCountTwo) +
            parseInt(receivedCountThree) +
            parseInt(receivedCountFour)
          );
          break;
        case "tweight":
          var weight = this.selectSubField("stock", "weight");
          var soldCount = this.selectField("soldCount");
          return formatToMoney(weight * soldCount);
        case "weight":
          return formatToMoney(this.selectSubField("stock", field));
          break;
        default:
          return this.selectField(field);
      }
    },
    selectField(field) {
      return this.stocks
        .map(function(n, i) {
          return n[field];
        })
        .reduce(function(a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    },
    selectSubField(field, subField) {
      return this.stocks
        .map(function(n, i) {
          return n[field][subField];
        })
        .reduce(function(a, b) {
          return parseFloat(a) + parseFloat(b);
        });
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.stocks.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    async saveAction() {
      await this.$store.dispatch("stockDetails/bulkUpdateStates", this.stocks);
      this.$store.state.dialog = true;
      this.$store.state.message = "İşleminiz Tamamlanmıştır.";
    }
  },
  async mounted() {
    await this.initialize();
  }
};
</script>
<style>
.redd {
  color: red;
}
</style>
